import styled from 'styled-components'

export const Link = styled.div`
  text-decoration: none;
`
